import { Pagination } from "antd";
import styled from "styled-components";

export const PaginationTextWrapper = styled.div`
  font-family: 'Manrope', sans-serif;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .pagination-text {
    font-family: 'Manrope', sans-serif;
    font-weight: 500;
    font-size: 0.875rem;
    leading-trim: Cap height;
    line-height: 100%;
    letter-spacing: 0%;
    color: #5a6c87;
  }
  .pagination-count {
    font-weight: 500;
  }
`;

export const CustomPagination = styled(Pagination)`
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.25rem;
  height: 32px;

  .control-btn {
    gap: 8px;
    display: flex;
    align-items: center;
  }
  li {
    &:nth-child(2) {
      border-top-left-radius: 6px;
      border-bottom-left-radius: 6px;
    }
    &:nth-last-child(2) {
      border-top-right-radius: 6px;
      border-bottom-right-radius: 6px;
    }
  }
  li {
    padding: 10px 16px;
    height: 32px;
    margin-inline-end: 0;
    display: flex;
    border: 1px solid var(--TABLE-BORDER-COLOR);
  }

  .ant-pagination-prev,
  .ant-pagination-next {
    height: auto !important;
    line-height: 20px;
    font-family: 'Manrope', sans-serif;
    display: flex;

    a {
      font-weight: 400;
      color: var(--TABLE-TEXT-COLOR);
    }

    &.ant-pagination-disabled {
      opacity: 0.4;
      cursor: not-allowed;
    }
  }
  .ant-pagination-prev {
    margin-right: 8px;
  }
  .ant-pagination-next {
    margin-left: 8px;
  }
  .ant-pagination-item {
    font-family: 'Manrope', sans-serif;
    line-height: 20px;
    border: 1px solid var(--TABLE-BORDER-COLOR);
    margin-inline-end: 0;
    border-radius: 0;
    height: auto !important;
    display: flex;
    align-items: center;

    &:hover {
      color: #0c53bb;
      background: #c3d5f1;
      border-color: var(--TABLE-BORDER-COLOR);
    }
    &:nth-child {
      border-top-left-radius: 5px !important;
    }

    a {
      font-weight: 400;
      padding: 0;
      color: #959ab1;
    }
  }
  .ant-pagination-item-active {
    font-family: 'Manrope', sans-serif;
    font-weight: 700; /* Bold active page */
    color: #0c53bb;
    background: #c3d5f1;

    a {
      font-family: 'Manrope', sans-serif;
      font-weight: 700; /* Bold active link */
      color: #0c53bb;
    }

    &:hover {
      a {
        color: #0c53bb;
        background: #c3d5f1;
      }
      color: #0c53bb;
      background: #c3d5f1;
      border-color: var(--TABLE-BORDER-COLOR);
    }
  }
  .ant-pagination-jump-next,
  .ant-pagination-jump-prev {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0px;
    margin-inline-end: 0px;
    height: auto !important;
    min-width: 43px;
    width: 44px;
    
    &:hover {
      border-color: var(--TABLE-BORDER-COLOR);
      
      a.ant-pagination-item-link {
        .ant-pagination-item-link-icon {
          display: block;
        }
        
        .ant-pagination-item-ellipsis {
          display: none;
        }
      }
    }
    
    a.ant-pagination-item-link {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      width: 100%;
      line-height: 1;
      
      .ant-pagination-item-container {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        width: 100%;
        position: relative;
      }
      
      .ant-pagination-item-link-icon {
        display: none;
        flex-shrink: 0;
      }
      
      .ant-pagination-item-ellipsis {
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 1;
        margin: 0;
        padding: 0;
        height: 100%;
        width: 100%;
        color: #959ab1;
        flex-shrink: 0;
      }
    }
  }
`;

export const PageSizeWrapper = styled.div`
  display: flex;
  align-items: baseline;
  color: #48566b !important;
  font-family: 'Manrope', sans-serif;
  font-weight: 500;
  font-size: 13px;
  leading-trim: Cap height;
  line-height: 100%;
  letter-spacing: 0%;
  gap: 5px;
`;
